module.exports = __webpack_public_path__ + "assets/icons/ic_equalizer-1f73.svg";